import React from 'react';

interface CongressFilterProps {
  selectedCongress: string | null;
  onCongressChange: (congress: string) => void;
  isLoading?: boolean;
}

const CongressFilter: React.FC<CongressFilterProps> = ({
  selectedCongress,
  onCongressChange,
  isLoading = false
}) => {
  return (
    <div>
      <span className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-200">Congressional Session</span>
      <button
        type="button"
        disabled={isLoading}
        onClick={() => onCongressChange('119')}
        className="block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-left text-sm font-medium text-gray-700 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
        aria-label="119th Congress only"
      >
        119th Congress (2025–2026)
      </button>
    </div>
  );
};

export default CongressFilter;
